/**
 * useQuotes Hook
 * 
 * Implementa Stale-While-Revalidate (SWR) para cotações com paginação.
 * sellerId = null busca todas as cotações
 * sellerId = 'xxx' filtra por vendedor
 */
import useSWR from 'swr'
import { api } from '../services/api'

const PER_PAGE = 10

export function useQuotes(sellerId = null, page = 1) {
  const cacheKey = sellerId 
    ? `quotes-seller-${sellerId}-page-${page}` 
    : `quotes-all-page-${page}`
  
  const { data, error, isLoading, mutate } = useSWR(
    cacheKey,
    () => api.getQuotes(sellerId, page, PER_PAGE),
    {
      revalidateOnFocus: true,
      refreshInterval: 30000,
      keepPreviousData: true,
      dedupingInterval: 2000,
    }
  )

  return {
    quotes: data?.items || [],
    total: data?.total || 0,
    page: data?.page || page,
    totalPages: data?.total_pages || 0,
    hasNext: data?.has_next || false,
    hasPrev: data?.has_prev || false,
    isLoading,
    isError: error,
    refresh: mutate
  }
}

/**
 * Hook para uma cotação específica
 */
export function useQuote(id) {
  const { data, error, isLoading, mutate } = useSWR(
    id ? `quote-${id}` : null,
    () => api.getQuote(id),
    {
      revalidateOnFocus: false,
      dedupingInterval: 5000,
    }
  )

  return {
    quote: data,
    isLoading,
    isError: error,
    refresh: mutate
  }
}
